import React, { useEffect, useState } from 'react';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../../components/Component';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_products, loading_retrieve_products, reset_retrieve_products, success_retrieve_products } from '../../../../reducers/auth_tenant/retrieve_products_Slice';
import * as app_consts from "../../../../utils/app_consts";
import { TENANT_RETRIEVE_SALES_REP_ORDER_ITEMS_BY_DATE_API } from '../../../../api/api_data';
import { useDispatch, useSelector } from 'react-redux';
import { addThreeDots, formatNumber, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import { RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, Input, UncontrolledDropdown } from 'reactstrap';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import moment from 'moment';

const SalesRepDetailsOrderReportsProducts = ({ start_date, end_date, tabName, tenant_info, user_info, sales_rep_id, data }) => {

 const [page_data, setPageData] = useState([]);
 const [date_range, setDateRange] = useState({ start_date: start_date, end_date: end_date, data });
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const [sent_sales_rep_id, setSentSalesRepID] = useState(sales_rep_id);
 const [current_page_data, setCurrentPageData] = useState([]);
 const [sm, updateSm] = useState(false);
 const [searchTerm, setSearchTerm] = useState((""));
 const [currentPage, setCurrentPage] = useState(1);
 const [categoryFilter, setCategoryFilter] = useState("All");
 const [itemPerPage] = useState(5); // Show 5 categories per page
 const [statusFilter, setStatusFilter] = useState("All");
 const [received_data, setReceivedData] = useState(data);

 useEffect(() => {
  setDateRange({ start_date: start_date, end_date: end_date });
  setSentSalesRepID(sales_rep_id);
  if (tabName === "Products")
  {
   retrieve_data(start_date, end_date, sales_rep_id);
  }
  setPageData(tabName);
  setReceivedData(data);
 }, [start_date, end_date, tabName, sales_rep_id, data]);

 const retrieve_data = (start_date, end_date, id) => {
  setError("");
  // Get the browser's timezone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get the browser's timezone offset in minutes
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

  dispatch(tenant_auth_actions_helper(loading_retrieve_products, success_retrieve_products, fail_retrieve_products, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_SALES_REP_ORDER_ITEMS_BY_DATE_API}/${id}/${start_date}${formattedOffset}/${end_date}${formattedOffset}`));
 };
 // Listen
 const retrieve_products_listener = useSelector((state) => state.retrieve_products.retrieve_products);

 useEffect(() => {
  if (retrieve_products_listener.status !== app_consts.IDLE)
  {
   if (retrieve_products_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_products_listener.status === app_consts.FAIL)
    {
     setError(retrieve_products_listener.message, app_consts.FAIL);
     messageToast(retrieve_products_listener.message, app_consts.FAIL);
    } else if (retrieve_products_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_products_listener.data);
     setCurrentPageData(retrieve_products_listener.data);
    }
    dispatch(reset_retrieve_products());
   }
  }
 }, [retrieve_products_listener]);

 // Group products by category with filtering and sorting
 const groupProductsByCategory = (products) => {
  if (!products) return [];

  // Recursively convert any value/object/array into searchable text
  const flattenForSearch = (value) => {
   if (value === null || value === undefined)
   {
    return "";
   }

   if (Array.isArray(value))
   {
    return value
     .map(flattenForSearch)
     .join(" ");
   }

   if (typeof value === "object")
   {
    return Object.values(value)
     .map(flattenForSearch)
     .join(" ");
   }

   return String(value);
  };

  // Apply filters
  let filtered = [...products];

  if (categoryFilter !== "All")
  {
   filtered = filtered.filter((item) =>
    categoryFilter === "Uncategorized"
     ? !item?.product?.category
     : item?.product?.category === categoryFilter
   );
  }

  if (statusFilter !== "All")
  {
   filtered = filtered.filter(
    (item) => item.status === statusFilter.toLowerCase()
   );
  }

  if (searchTerm)
  {
   const search = searchTerm
    .trim()
    .toLowerCase();

   filtered = filtered.filter((item) => {
    const searchStr = flattenForSearch(item)
     .replace(/_/g, " ")
     .toLowerCase();

    return searchStr.includes(search);
   });
  }

  // Group by product category
  const grouped = filtered.reduce((acc, product) => {
   const category =
    product?.product?.category || "Uncategorized";

   if (!acc[category])
   {
    acc[category] = [];
   }

   acc[category].push(product);

   return acc;
  }, {});

  return Object.entries(grouped)
   .map(([category, items]) => ({
    category,
    items: items.sort((a, b) =>
     a.name?.localeCompare(b.name)
    ),
    count: items.length
   }))
   .sort((a, b) =>
    a.category?.localeCompare(b.category)
   );
 };
 // Get all unique categories for filter dropdown
 const getUniqueCategories = (products) => {
  if (!products) return [];
  const categories = new Set(products.map(p => p?.product?.category || 'Uncategorized'));
  return ['All', ...Array.from(categories).sort()];
 };

 const groupedProducts = groupProductsByCategory(current_page_data);
 const uniqueCategories = getUniqueCategories(current_page_data);

 // Pagination for categories
 const indexOfLastCategory = currentPage * itemPerPage;
 const indexOfFirstCategory = indexOfLastCategory - itemPerPage;
 const currentCategories = groupedProducts.slice(indexOfFirstCategory, indexOfLastCategory);
 const totalCategories = groupedProducts.length;

 const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);
  window.scrollTo(0, 0); // Scroll to top when changing pages
 };

 const export_to_csv = (e) => {
  e.preventDefault();
  const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

  const csv_headers = [
   "Order Ref Number",
   "Order Name/Destination",
   "Product Name",
   "Brand",
   "Units",
   "Size",
   "Color",
   "Unit Per Value (ZMW)",
   "Total Value (ZMW)",
   "Status"
  ];

  const csv_data = groupedProducts?.flatMap((group) => {
   return group?.items.map((item, idx) => {
    return {
     order_ref_number: item?.order?.order_ref_number,
     order_name: item?.order?.order_name,
     product_name: item?.product?.name,
     brand: item?.product?.category,
     units: item?.order_item?.units,
     size: item?.order_item?.size,
     color: item?.order_item?.color,
     unit_per_value: formatNumber(item?.order_item?.unit_value) || 0.00,
     total_value: formatNumber(item?.order_item?.total_value) || 0.00,
     status: item?.order_item?.status
    };
   });
  });

  const options = mkConfig({
   fieldSeparator: ',',
   quoteStrings: '"',
   showLabels: true,
   showTitle: false,
   title: " ",
   useTextFile: false,
   useBom: true,
   filename: `${received_data?.sales_rep?.name}'s Order Products Report from ${date_range?.start_date} to ${date_range?.end_date} as at ${cur_dt}`,
   useKeysAsHeaders: true,
   columnHeaders: csv_headers,
  });

  const csv = generateCsv(options)(csv_data || []);

  download(options)(csv);

 };


 return (
  <>
   {
    loading ?
     <>
      <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Products..." />
     </>
     :
     <>
      {
       error ?
        <>
         <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
        </>
        :
        <>
         {
          page_data ?
           <>
            <BlockHead size="sm">
             <BlockBetween>
              <BlockHeadContent>
               <BlockDes className="text-soft">
                <p>{!(loading || error) && current_page_data?.length > 0 && `Total Products ${current_page_data?.length}`}</p>
               </BlockDes>
               {!loading && (
                <>
                 <div className="mt-2 d-flex justify-content-end mb-3">
                  <Button
                   color="light"
                   outline
                   className="bg-white d-none d-sm-inline-flex mx-2"
                   onClick={() => retrieve_data(date_range?.start_date, date_range?.end_date, sent_sales_rep_id)}
                  >
                   <span>Refresh List</span>
                  </Button>
                  <Button
                   color="primary"
                   className="btn-primary"
                   onClick={export_to_csv}
                  >
                   <Icon name="download-cloud" />
                   <span>Export to CSV</span>
                  </Button>
                 </div>
                </>
               )}
              </BlockHeadContent>
              {!(loading || error) && (
               <BlockHeadContent>
                <div className="toggle-wrap nk-block-tools-toggle">
                 <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                   ev.preventDefault();
                   updateSm(!sm);
                  }}
                 >
                  <Icon name="more-v"></Icon>
                 </a>
                 <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                   <li>
                    <div className="form-control-wrap">
                     <div className="form-icon form-icon-right">
                      <Icon name="search"></Icon>
                     </div>
                     <Input
                      type="text"
                      className="form-control"
                      id="default-04"
                      value={searchTerm}
                      onChange={e => {
                       setSearchTerm(e.target.value);
                       setCurrentPage(1);
                      }}
                      placeholder="Search products..."
                     />
                    </div>
                   </li>
                   <li>
                    <UncontrolledDropdown>
                     <DropdownToggle color="light" outline className="bg-white dropdown-toggle">
                      {categoryFilter === "All" ? "All Categories" : categoryFilter}
                     </DropdownToggle>
                     <DropdownMenu>
                      <DropdownItem onClick={() => setCategoryFilter("All")}>All Categories</DropdownItem>
                      {uniqueCategories.filter(c => c !== "All").map(category => (
                       <DropdownItem
                        key={category}
                        onClick={() => {
                         setCategoryFilter(category);
                         setCurrentPage(1);
                        }}
                       >
                        {category}
                       </DropdownItem>
                      ))}
                     </DropdownMenu>
                    </UncontrolledDropdown>
                   </li>
                   <li>
                    <UncontrolledDropdown>
                     <DropdownToggle color="light" outline className="bg-white dropdown-toggle">
                      {statusFilter === "All" ? "All Status" : statusFilter}
                     </DropdownToggle>
                     <DropdownMenu>
                      <DropdownItem onClick={() => setStatusFilter("All")}>All Status</DropdownItem>
                      <DropdownItem onClick={() => setStatusFilter("Active")}>Active</DropdownItem>
                      <DropdownItem onClick={() => setStatusFilter("Inactive")}>Inactive</DropdownItem>
                      <DropdownItem onClick={() => setStatusFilter("Archive")}>Archive</DropdownItem>
                     </DropdownMenu>
                    </UncontrolledDropdown>
                   </li>
                  </ul>
                 </div>
                </div>
               </BlockHeadContent>
              )}
             </BlockBetween>
            </BlockHead>
            {currentCategories.length > 0 ? (
             currentCategories.map((group) => (
              <div key={group.category} className="mb-4">
               <div className="d-flex flex-column mb-3">
                <h5 className="title" style={{ fontWeight: '600', color: '#2c3e50' }}>
                 {group.category}
                </h5>
                <div>
                 <Badge color="primary" className="w-auto badge-dim">
                  {group.count} {group.count === 1 ? 'product' : 'products'}
                 </Badge>
                </div>
               </div>
               <Block>
                <div className="nk-tb-list is-separate is-medium mb-3">
                 <DataTableHead className="nk-tb-item">
                  <DataTableRow>
                   <span className="sub-text">Order Ref No</span>
                  </DataTableRow>
                  <DataTableRow>
                   <span className="sub-text">Product</span>
                  </DataTableRow>
                  <DataTableRow>
                   <span className="sub-text">Brand</span>
                  </DataTableRow>
                  <DataTableRow>
                   <span className="sub-text">Units</span>
                  </DataTableRow>
                  <DataTableRow>
                   <span className="sub-text">Total Value</span>
                  </DataTableRow>
                  <DataTableRow>
                   <span className="sub-text">Status</span>
                  </DataTableRow>
                  {/* <DataTableRow>
                   <span className="sub-text">Action</span>
                  </DataTableRow> */}
                 </DataTableHead>
                 {group?.items.map((item, idx) => (
                  <DataTableItem key={item?.id} className="tb-tnx-item">
                   <DataTableRow>
                    <div className="user-card">
                     <div className="user-info">
                      <span className="tb-lead">
                       {item?.order?.order_ref_number || "--"}
                      </span>
                      <span>{addThreeDots(item?.order?.order_name || "--", 30)}</span>
                     </div>
                    </div>
                   </DataTableRow>
                   <DataTableRow>
                    <span className="tb-product">
                     <div className="me-3" style={{ width: '60px', height: '60px' }}>
                      <img
                       src={item?.product?.product_img}
                       alt={item?.product?.name}
                       className="img-thumbnail rounded"
                       style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        backgroundColor: '#f8f9fa'
                       }}
                      />
                     </div>
                     <span className="tb-sub">{item?.product?.name || "--"}</span>
                    </span>
                   </DataTableRow>
                   <DataTableRow>
                    <span className="tb-sub">{item?.product?.category || "--"}</span>
                   </DataTableRow>
                   <DataTableRow>
                    <div className="user-card">
                     <div className="user-info">
                      <span className="tb-lead">
                       {item?.order_item?.units || "--"}
                      </span>
                      <span>{item?.order_item?.size || "--"}</span> | <span>{item?.order_item?.color || "--"}</span>
                     </div>
                    </div>
                   </DataTableRow>
                   <DataTableRow>
                    <div className="user-card">
                     <div className="user-info">
                      <span className="tb-lead">
                       {formatNumber(item?.order_item?.total_value) || "--"} ZMW
                      </span>
                      Per Unit | <span>{formatNumber(item?.order_item?.unit_value) || "--"}</span>
                     </div>
                    </div>
                   </DataTableRow>
                   <DataTableRow size="md">
                    <span className="tb-odr-status">
                     <Badge
                      color={
                       item?.order_item?.status === app_consts.DISPATCHED_LOWER || item?.order_item?.status === app_consts.APPROVED_LOWER
                        ? "success"
                        : "warning"
                      }
                      className="badge-dot"
                     >
                      {formatToSentenceCase(item?.order_item?.status)?.toUpperCase() || "--"}
                     </Badge>
                    </span>
                   </DataTableRow>
                   {/* <DataTableRow className="nk-tb-col-tools">
                    <div className="tb-odr-btns d-none d-sm-inline">
                     <Button color="primary" size="sm" className="btn btn-dim">
                      View Details
                     </Button>
                    </div>
                    <Button className="btn-pd-auto d-sm-none">
                     <Icon name="chevron-right"></Icon>
                    </Button>
                   </DataTableRow> */}
                  </DataTableItem>
                 ))}
                </div>
               </Block>
              </div>
             ))
            ) : (
             <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No products match your filters"} />
            )}

            {totalCategories > 0 && (
             <div className="mt-4">
              <PaginationComponent
               itemPerPage={itemPerPage}
               totalItems={totalCategories}
               paginate={paginate}
               currentPage={currentPage}
              />
             </div>
            )}
           </>
           :
           <>
            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No products match your filters"} />
           </>
         }
        </>
      }
     </>
   }
  </>
 );
};

export default SalesRepDetailsOrderReportsProducts;